import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function EyeIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M2.16 8.408c-.082-.124-.124-.185-.147-.28a.6.6 0 0 1 0-.256c.023-.095.065-.156.148-.28C2.847 6.574 4.889 4 8 4s5.153 2.574 5.84 3.592c.082.124.124.185.147.28a.6.6 0 0 1 0 .256c-.023.095-.065.156-.148.28C13.153 9.426 11.111 12 8 12S2.847 9.426 2.16 8.408" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M8 9.714c1.01 0 1.829-.767 1.829-1.714S9.009 6.286 8 6.286c-1.01 0-1.828.767-1.828 1.714S6.99 9.714 8 9.714" /></svg>
  );
}

export default EyeIcon;
